import {Status as AutomationFileStatusGraphQL} from 'graphql-client/__generated/graphqlGlobalTypes';

import {AutomationInputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationInputFileGraphQL';
import {ResultBlobGraphQL} from '../../../graphql-fragments/results/__generated/ResultBlobGraphQL';
import getStatusForInputFileViewer from './getStatusForInputFileViewer';

export default function getFinalInputFileBlob(
  automationInputFile: AutomationInputFileGraphQL
): ResultBlobGraphQL | null {
  if (getStatusForInputFileViewer(automationInputFile) !== AutomationFileStatusGraphQL.succeeded) {
    return null;
  }

  const transformFiles = automationInputFile.transformFiles.filter((transformFile) => transformFile != null);

  return transformFiles.length > 0
    ? transformFiles[transformFiles.length - 1].blob!
    : automationInputFile.blob!;
}
